
/**
 * @name PreferencesController
 * @constructor
 * @param {any} $scope
 * @param {import("core-services/preferences.service").PreferencesService} PreferencesService
 */
export function PreferencesController($scope, PreferencesService) {
  if ($scope.setControllerName)
    $scope.setControllerName('PreferencesCtrl');

  $scope.status = PreferencesService.status;
  $scope.preferences = PreferencesService.preferences;

  $scope.selectPreference =
    function(preference) {
      return PreferencesService.updatePreference(preference)
        .then(function() {
          $scope.$applyAsync();
        });
    };

    PreferencesService.fetchPreferences();
};

export default [
  '$scope',
  'PreferencesService',
  PreferencesController
];